import { WebParameterContext, WebResponesContext } from '../../model/common';
export class ServicesRepurchaseRemark{
  constructor(
  ) {

  }
  public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
    // console.log("门店信息");
    if(webcontext.ConfigType.toLowerCase()=="form" && webcontext.OpType.toLowerCase()=="edite"){//沟通记录
        let request = JSON.parse(webcontext.RequestBody);
        webcontext.OpType="ADD";
        let _obj = {};
        webcontext.ConfigName="CommunicationRecordXML";
        _obj["a_CommunicationContent"]=request.a_CommunicationContent;//备注信息
        _obj["a_FK_MembersInfoManagement_ID"]=request["a_ID"];
        _obj["a_FK_SystemUser_ID"]=webcontext.Account.Id;
        let storeID =localStorage.getItem("tbstore");
        if(storeID){
            _obj["a_FK_TBStore_ID"]=JSON.parse(storeID)["ID"];
        }
        if(!request.a_CommunicationContent){
            webcontext.ResponseMessage.Success=false;
            webcontext.ResponseMessage.ErrorMessage="沟通记录必填";
        }else if(request.a_CommunicationContent.length<=15){
            webcontext.ResponseMessage.Success=false;
            webcontext.ResponseMessage.ErrorMessage="沟通记录必须大于15个字";
        }
      webcontext.RequestBody = JSON.stringify(_obj);
    }

    return webcontext;
  }
  public HandleServerContextAfterDBRequest(webParameterContext:WebParameterContext,webContext:WebResponesContext):WebResponesContext {
   const that = this;
   
    return webContext
  }
  

}